module.exports = __webpack_public_path__ + "img/03.afbe316e.png";